<!-- 表情评价组件 -->
<template>
  <div class="advance-emoj-rate">
    <div
      class="emoj-item"
      v-for="(item, index) of emojList"
      :key="index"
      :class="curIdx === item.value ? 'emoj-item-active' : ''"
      @click.stop="chooseCurEmoj(item, index)"
    >
      <i
        class="emoj-rate-icon iconfont"
        v-html="item.unicode"
      ></i>
      <!-- <el-image
        v-else
        :src="item.imageUrl"
        class="emoj-rate"
      /> -->
      <span class="emoj-text">{{ item.label }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      curIdx: null
    }
  },
  mounted () {
    this.curIdx = this.$attrs.__config__.defaultValue
  },
  computed: {
    emojList () {
      const list = this.$attrs.topicData.collect
      const limit = this.$attrs.max
      if (limit === 5) {
        return list
      } else if (limit === 3) {
        return list.filter(item => item.value === 1 || item.value === 3 || item.value === 5)
      } else {
        return list.filter(item => item.value === 1 || item.value === 5)
      }
    }
  },
  methods: {
    chooseCurEmoj (item) {
      this.curIdx = item.value
      this.$emit('chooseNpsData', item.value)
    }
  }
}
</script>
<style lang="stylus" scoped>
.advance-emoj-rate
  // max-width 375px
  display flex
  justify-content space-around
  margin-top 15px
  .emoj-item
    display flex
    flex-direction column
    justify-content flex-start
    align-items center
    text-align center
    cursor pointer
  .emoj-rate
    width 48px
    height 48px
    cursor pointer
  .emoj-rate-icon
    width 48px
    height 48px
    font-size 36px
    line-height 48px
    color #b2b2b2
  .emoj-text
    display inline-block
    color #333
    font-size 12px
    max-width 90px
    padding 15px 0
    overflow hidden
    line-height 22px
  .emoj-item-active
    .emoj-rate
      box-shadow 0px 0px 6px 1px rgba(255, 197, 0, 0.4)
      border-radius 5px
    .emoj-rate-icon
      color #ffc500
    .emoj-text
      font-weight 600
      color #000
</style>